import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '../../Common/ui/button'
import { IoAdd } from 'react-icons/io5'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as RiskTypes from '../../Entities/RiskTypes'
import { IoMdCloseCircle } from 'react-icons/io';
import { FaRegCircle } from 'react-icons/fa6';
import { Tooltip } from '@mui/material'
import '../../Styles/AddOnTable.css'
import { cn } from 'src/lib/utils';
import DatePickerInput from './DatePickerInput';
const AddOnTable = ({ header, setTasks, tasks, riskDeails, errors, control }) => {
  const userId = localStorage.getItem('userId')
  const addTask = () => {
    const newTask = {
      id: 0,
      task: '',
      startDate: '', // Ensure it's initialized
      endDate: '',   // Ensure it's initialized
      createdBy: userId,
      riskId: riskDeails?.id || 0,
      newUpdate: true,
      status: RiskTypes.TASK_INITIAL
    };
    setTasks([...tasks, newTask]);
  };
  const deleteTask = (id) => {
    const updatedTasks = tasks.map((task) => {
      if (userId === task?.createdBy) {
        return task.id === id ? { ...task, status: RiskTypes.TASK_HARD_REJECTED_STATUS } : task
      } else {
        return task.id === id ? { ...task, modifiedBy: userId, actions: task?.actions ? null : RiskTypes.TASK_REJECTED_STATUS } : task
      }
    }).filter(ele => ele !== null)
    setTasks(updatedTasks);
  };
  const handleInputChange = (id, value, index) => {
    const updatedTasks = tasks.map((task, mapIdx) =>
      mapIdx === index ? { ...task, task: value } : task
    );
    setTasks(updatedTasks);
  };

  const taskSelectChange = (value, index, dateType) => {
    const updatedTasks = tasks.map((task, i) =>
      i === index ? { ...task, [dateType]: value } : task
    )
    setTasks(updatedTasks)
  }

  return (
    <TableContainer className='suggest-mitigation-table' sx={{ borderRadius: 2, border: '1px solid hsl(var(--border))', overflow: 'hidden' }}>
      <Table
        border="1px solid hsl(var(--border))"
        width="100%"
        style={{ textAlign: 'left', borderCollapse: 'collapse' }}
      >
        <TableHead>
          <TableRow>
            {header.map((element) => (
              <TableCell align={element === 'Task' ? 'left' : 'center'} sx={{ backgroundColor: 'hsl(var(--primary-foreground))' }}>{element}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tasks?.map((task, index) => (
            <>
              {<TableRow sx={{ backgroundColor: task?.id !== 0 && 'hsl(var(--popover))' }} key={task?.id}>
                <TableCell ><div style={{ borderLeft: `8px solid ${task.actions === 11 ? 'hsl(var(--destructive))' : 'hsl(var(--Low))'}` }} className='my-[-16px] mx-[-16px] py-[16px] px-[16px] flex flex-col justify-center items-center'><div className='pr-[16px] border-r-2 border-border'><span className='h-[30px] text-primary flex flex-col justify-center items-center w-[30px] rounded-full bg-primary-foreground'>{index + 1}</span></div></div></TableCell>
                <TableCell >
                  <div >
                    <textarea
                      disabled={task?.id !== 0}
                      value={task?.task}
                      onChange={(e) => handleInputChange(task?.id, e.target.value, index)}
                      placeholder="Enter task"
                      className='!border-none !outline-none w-full !ring-0 !shadow-none h-fit'
                    />

                  </div>
                </TableCell>
                <TableCell sx={{ height: '100%', width: '24%' }} >
                  <p className={cn(' task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                    <DatePickerInput
                      errors={errors}
                      control={control}
                      name={`startDate_${index}`}
                      value={task?.startDate}
                      defaultValue={task?.startDate}
                      onValueChange={(e) => { taskSelectChange(e, index, 'startDate') }}
                    />
                  </p>
                </TableCell>
                <TableCell sx={{ height: '100%', width: '24%' }} >
                  <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                    <DatePickerInput
                      errors={errors}
                      control={control}
                      minDate={task?.startDate || ''}
                      name={`endDate_${index}`}
                      value={task?.endDate}
                      defaultValue={task?.endDate}
                      onValueChange={(e) => { taskSelectChange(e, index, 'endDate') }}
                    />
                  </p>
                </TableCell>
                <TableCell>
                  <div className='flex flex-col justify-center items-center border-l-2 border-border'>
                    <button
                      disabled={task?.actions === RiskTypes.TASK_REJECTED_STATUS && !task?.newUpdate}
                      style={{ border: 'none', background: 'transparent' }}
                    >
                      {task?.id !== 0 ? task?.actions === RiskTypes.TASK_REJECTED_STATUS ? <IoMdCloseCircle onClick={() => deleteTask(task?.id)} color={task?.actions === RiskTypes.TASK_REJECTED_STATUS && !task?.newUpdate ? 'hsl(var(--muted))' : 'hsl(var(--destructive))'} size={20} /> : <Tooltip title="Disapprove" placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><FaRegCircle color='hsl(var(--destructive))' onClick={() => deleteTask(task?.id)} size={20} /></Tooltip>
                        : <Tooltip title="Delete Task" placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                          <img onClick={() => { setTasks(tasks?.filter((_, filterIdx) => filterIdx !== index)) }} src='/Assets/DeleteBinIcon.svg' style={{ height: '20px' }} alt="Delete" />
                        </Tooltip>
                      }
                    </button>
                  </div>
                </TableCell>
              </TableRow>}
            </>
          ))}
        </TableBody>
      </Table>
      <Dialog.Root>
        <Dialog.Trigger asChild>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant='outlined'
              component='label'
              size='small'
              disabled={tasks?.[tasks?.length - 1]?.task?.length <= 0}
              style={{ margin: '1rem', width: '110px', height: '50%', fontWeight: 'bold', fontSize: '12px', color: 'hsl(var(--primary))', border: '2px solid hsl(var(--primary))' }}
              onClick={addTask}
            >
              <span className="flex items-center" style={{ fontWeight: 'bold' }}>
                <IoAdd className="mr-2" size={15} /> Add Task
              </span>
            </Button>
          </div>
        </Dialog.Trigger>
      </Dialog.Root>
    </TableContainer>
  );
};

export default AddOnTable;
